import React, { useState, useEffect, useLayoutEffect } from "react";
import AuthService from "../../utils/AuthService";
import ApiMap from "../../utils/ApiMap";
import axios from "axios";
import CourseCard from "./CourseCard";
import { Button, Box } from "@mui/material";

const ViewCoursePage = ({ setShowAppBar }) => {
  const [enrollments, setEnrollments] = useState(null);
  const [assignmentDueCountLoaded, setAssignmentDueCountLoaded] =
    useState(false);

  useEffect(() => {
    const fetchMyAssignmentsDue = async () => {
      try {
        const resp = await axios(
          `${ApiMap.MY_ASSIGNMENTDUECOUNT}`,
          AuthService.getAuthHeader()
        );
        AuthService.setAssignmentsDueCount(resp.data);
      } catch (error) {
        console.error("Error fetching assignments due:", error);
      }
    };

    if (AuthService.isLoggedIn() && !assignmentDueCountLoaded) {
      setAssignmentDueCountLoaded(true);
      fetchMyAssignmentsDue();
    }
  }, [assignmentDueCountLoaded]);

  useEffect(() => {
    if (AuthService.isLoggedIn()) {
      const userCourses = AuthService.getUserCourses();
      setEnrollments(userCourses);
    }
  }, []);

  return (
    <Box>
      <Box
        sx={{
          textAlign: "center",
          mt: 2,
        }}
      >
        <Button></Button>
      </Box>

      <Box
        display="flex"
        flexDirection="row"
        flexWrap="wrap"
        justifyContent="center"
        p={1}
        m={1}
      >
        <CourseCard courses={enrollments} />
      </Box>
    </Box>
  );
};

export default ViewCoursePage;
